import { ShippingFlagKey } from "@redotech/feature-flags-keys-shipping/keys";
import type { SettingAvailabilityContext } from "./types";

export function hasShippingNewSettings(
  context?: SettingAvailabilityContext,
): boolean {
  return (
    context?.evaluatorData?.featureFlagsByKey?.[
      ShippingFlagKey.SHIPPING_NEW_SETTINGS
    ] === true
  );
}
